<template>
  <div id="stock-item-list">
    <b-card>
      <b-row>
        <b-col md="6">
          <h3>{{ $route.name }}</h3>

          <!-- breadcrumb -->
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item to="/inventory/stock-item-list/" active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <!-- end breadcrumb -->
        </b-col>
      </b-row>
       <!-- <div class="border-bottom"></div> -->


      <b-row class="mb-3">
        <b-col md="4 mb-2">
              <b-input-group>
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  placeholder="Search by Name"
                ></b-form-input>
              </b-input-group>
            </b-col>
        <!-- <b-col>
        <p>filter here</p>

        </b-col> -->
      </b-row>

       <b-table id="my-table"
          :items="stockItemListData"
          :busy="isLoading"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
          responsive
          striped
          center
          show-empty>
          <template v-slot:table-busy>
          <div class="text-center" style="margin: 3% auto;">
            <b-spinner small type="grow" label="Small Spinner"></b-spinner>
            <b-spinner small variant="primary" type="grow" label="Small Spinner"></b-spinner>
            <b-spinner small variant="success" type="grow" label="Small Spinner"></b-spinner>
          </div>
        </template>
         <!-- @filtered="onFiltered" -->
         <template #cell(itemListName)="row">
           {{row.item.itemListName}}
         </template>
         <template #cell(stockItemCogs)="row">
          {{ dataAccount.account.currency }} {{row.item.stockItemCogs !==null ? formatPrice(row.item.stockItemCogs) : '-' }}
         </template>
          <template #cell(totalStockOutItem)="row">
          {{row.item.totalStockOutItem !==null ? row.item.totalStockOutItem : '-' }}
         </template>
         <!-- <template #cell(actions)="row">
           <div class="text-center">
              <a v-b-tooltip.hover.bottom title="Details" class="btn-op icon-info mr-1" :href="'#/inventory/stock-item-list' + '/' + row.item.itemListUuid"></a>
           </div>
         </template> -->
       </b-table>  
    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      per-page="perPage"
      class="justify-content-end"
    ></b-pagination>

  

    </b-card>
  </div>
</template>

<script>
export default {
  data(){
    return {
      isLoading: false,
      perPage: 25,
      pageOptions: 1,
      totalRows: 1,
      currentPage: 1,
      filtered: '',
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      dataAccount: this.$store.getters['account/accountData'],
      apiUrl: {
        stockItemData: window.AppConfig.apiUrl + 'stock-item-data',
    },

    stockItemListData: [],
    fields: [
      {
        key: 'itemListName',
        label: 'Name',
        class: 'name-item'
      },
      {
        key: 'stockItemCogs',
        label: 'Cost Of Goods Price',
        class: 'text-center'
      },
      {
        key: 'totalStockItem',
        label: 'Stock Total',
        class: 'text-center'
      },
      {
        key: 'totalStockInItem',
        label: 'Stock In Total',
        class: 'text-center'
      },
      {
        key: 'totalStockOutItem',
        label: 'Stock Out Total',
        class: 'text-center'
      },
      // {
      //   key: 'actions',
      //   label: '',
      // }
    ]
    }
  },

  mounted() {
    this.getDataStockItem()
    this.totalRows = this.pageOptions
  },

  methods: {
    
    /**
     * @function getDataStockItem
     * @async
     */
      async getDataStockItem (){
        this.isLoading = true
        const response = await this.$http.get(this.apiUrl.stockItemData)
        let t = this
        t.totalRows = response.data.length
        t.stockItemListData = response.data
        setTimeout(()=> {
          t.isLoading = false
        }, 600)
        // t.currentPage = response.data.length
        console.log('table data is:', t.stockItemListData);
      },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },

      /* Trigger pagination to update the number of buttons/pages due to filtering */
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

  },


  
}

</script>

<style lang="sass">
.name-item
  white-space: pre-line
  width: 50%
</style>